import { FC } from "react";
import { Alert, FormControl, FormControlProps, Switch } from "@mui/material";
import { Controller } from "react-hook-form";
import { ControllerProps } from "react-hook-form";
import CustomLabelInput from "@components/CustomLabelInput";

interface ReactHookFormSwitchProps extends FormControlProps {
  label: string;
  subtitle?: string;
  controller: Omit<ControllerProps<any>, "render">;
}

const ReactHookFormSwitch: FC<ReactHookFormSwitchProps> = ({
  label,
  subtitle,
  controller,
  ...props
}) => {
  const labelId = `${controller.name}-label`;
  return (
    <CustomLabelInput label={label} labelId={labelId}>
      {(subtitle) && (
      <Alert variant="standard" severity="info" color="info">
        {subtitle}
      </Alert>
      )}
      <FormControl {...props}>
        <Controller
          render={({ field }) => (
            <Switch
              {...field}
              defaultValue={controller.defaultValue}
              checked={field.value}
            />
          )}
          {...controller}
        />
      </FormControl>
    </CustomLabelInput>
  );
};

export default ReactHookFormSwitch;
